import React from "react";
import Avatar from "../../avatar";
import { OfficialRating } from "../../../types";

const PlayerItemSmall = ({
	name,
	photoUrl,
	isBuddy,
	points,
	extra = "",
}: // officialRating = null,
{
	name: string;
	photoUrl: string;
	isBuddy?: boolean;
	points?: string;
	extra?: string;
	// officialRating?: OfficialRating;
}) => {
	return (
		<div className={`item player small ${extra}`}>
			<div className="itemImage">
				{isBuddy ? <div className="buddy"></div> : null}
				{/* {officialRating?.code ? <div className="verifiedRating"></div> : null} */}
				<Avatar photoUrl={photoUrl} />
			</div>
			<div className="itemBody">
				<div className="title">{name}</div>
			</div>
			<div className="itemExtra">{points ? <div className="points">{points} pts</div> : null}</div>
		</div>
	);
};

export default PlayerItemSmall;
